(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart__main"]) return;
  try {
    
  // Check for shared cart
  if (location.hash.indexOf('#') !== -1) {
    var items = atob(location.hash.split('#')[1]);
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      dataType: 'json',
      success: function() {
        setTimeout(function(){
          debugger;
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: `{"items":${items}}`
        })
        .then(response => {
          if (response.status !== 200) {
            alert('Oops! There is an issue with this saved cart. Please get a new link and try again.');
          } else {
            location.href = '/cart';
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          alert('Oops! There was a server error');
        });
        },600)
      }
    });
    
  }

  } catch(e) { console.error(e); }
})();
})();
